import React, { useEffect, useState } from 'react'
import { AddDomainName, DeleteDomain, getDomainName } from '../../Services/allApi'
import { toast, ToastContainer } from 'react-toastify'
import { Icon } from '@iconify/react/dist/iconify.js'

function DomainName() {
    const [domainName, setDomainName] = useState()
    const [DomainList, setDomainList] = useState([])
    const [domainUpdateResponse, setDomainUpdateResponse] = useState(1)
    useEffect(() => {
        getDomain()
    }, [domainUpdateResponse])
    const domainSuggestions = [
        "example.com",
        "mywebsite.org",
        "cooldomain.net",
        "yourcompany.io",
        "mydomain.dev"
    ];
    const getDomain = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await getDomainName(reqHeader)
        console.log(result);
        setDomainList(result?.data?.data)
    }
    const addDomain = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const res = await AddDomainName({ domain_name: domainName }, reqHeader)
        if (res?.status == 200) {
            toast.success("Domain updated successfully")
            setDomainUpdateResponse(domainUpdateResponse + 1)
        } else {
            toast.error(res?.response?.data?.message ?? 'There was a problem updating the domain name')
        }
        console.log(res);
    }
    const handleDelte = async (e) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const res = await DeleteDomain(e, reqHeader)
        if (res?.status == 200) {
            toast.success("Domain deleted successfully")
            setDomainUpdateResponse(domainUpdateResponse + 1)
        } else {
            toast.error(res?.response?.data?.message ?? 'There was a problem deleting the domain name')
        }
    }
    return (
        <>
            <div className='flex w-full h-full justify-center items-center flex-col'>
                {/* note */}
                <div className='flex flex-row justify-end mt-5 '>
                    <div className='font-bold uppercase '>
                        <span className='text-blue-700 me-1'>Note: </span> <span className='border py-1 border-yellow-500 text-yellow-900 bg-yellow-100 px-1 rounded-s'>Domain name determines the location where the video and contents to be stored</span>
                    </div>
                </div>
                <div className='w-6/12 pt-10 flex justify-center flex-col'>
                    <label htmlFor="dn">Add New Domain Name</label>
                    <div className='flex flex-row gap-2 w-full pb-5 '>
                        <input value={domainName} onChange={(e) => setDomainName(e.target.value)} id='dn' type="text" placeholder='Entre the domain name' className='w-10/12 h-10 rounded-lg border border-gray-700 px-2'
                        />
                        <div className=' w-3/12 flex justify-center'>
                            <button className='w-full py-2 bg-primary rounded-lg text-white' onClick={addDomain}>Submit</button>
                        </div>
                    </div>
                </div>
                <div className='w-11/12 bg-success  shadow-md rounded-lg border h-full p-5 mt-5 border-gray-200'>
                    <h1 className='text-center text-blue-500 font-bold'>Existing Domains</h1>

                    <div className='flex flex-row flex-wrap w-full gap-4 pt-5'>
                        {DomainList?.map((domain) => (
                            <div className='bg-white border border-gray-300 text-gray-700 rounded-lg px-2 flex flex-row items-center gap-2' key={domain?.id}><span>{domain?.domain_name}</span><span className='text-red-600 hover:text-red-500 cursor-pointer' onClick={() => handleDelte(domain?.id)}><Icon icon="ic:outline-delete" /></span></div>
                        ))}
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}

                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    )
}

export default DomainName